import { Entity } from '@app/core';
import { IBump, IBumpModule, IBumpModuleGroup } from '@games/interfaces';

export class Bump extends Entity<IBump> {
  constructor(props: IBump) {
    super(props);
  }

  get name(): string {
    return this.props.bumpName;
  }

  get description(): string {
    return this.props.description;
  }

  get value(): number {
    return this.props.default;
  }

  get min(): number {
    return this.props.min;
  }

  get max(): number {
    return this.props.max;
  }

  get periods(): any {
    return this.props.periods;
  }

  set morePeriods(periods: any) {
    this.props.periods = { ...this.props.periods, ...periods };
  }

  // Quiz-style fields
  get question(): string | undefined {
    return this.props.question;
  }

  get choices(): any[] | undefined {
    return this.props.choices;
  }

  get selectedChoice(): string | null | undefined {
    return this.props.selectedChoice;
  }

  get rationale(): string | undefined {
    return this.props.rationale;
  }

  get rationaleMaxLength(): number | undefined {
    return this.props.rationaleMaxLength;
  }
}

export class BumpModule extends Entity<IBumpModule> {
  constructor(props: IBumpModule) {
    super(props);
  }

  get id(): number {
    return this.props.id;
  }

  get name(): string {
    return this.props.name;
  }

  get moduleName(): string {
    return this.props.moduleName;
  }

  get bumps(): Bump[] {
    return this.props.bumps && this.props.bumps.map((bump: IBump) => new Bump(bump));
  }
}

export class BumpModuleGroup extends Entity<IBumpModuleGroup> {
  constructor(props: IBumpModuleGroup) {
    super(props);
  }

  get name(): string {
    return this.props.name;
  }

  get modules(): BumpModule[] {
    return (
      this.props.modules && this.props.modules.map((module: IBumpModule) => new BumpModule(module))
    );
  }
}
